import * as React from "react";
import SearchIcon from "@material-ui/icons/Search";
import "../../styles/Result/ResultFooter.scss";

export const ResultFooter = ({searchAgain}) => {
  return (<div className="configurator-result-footer">
    <button onClick={() => searchAgain()} className="configurator-result-footer__search-button">WYSZUKAJ PONOWNIE<SearchIcon
      className="configurator-result-footer__search-icon"/></button>
  </div>)
}